import { MarketGroupDto } from '@core/mappers/struct/dtos/MarketGroupDto';
import MarketGroupInfo from '@models/struct/MarketGroupInfo';
import { getConfig } from '@superbet-group/web.lib.config';

export function mapMarketGroups(dto: MarketGroupDto): MarketGroupInfo {
    return {
        id: dto.id,
        name: dto.localNames[getConfig().appLocale.locale]!,
        order: dto.order,
        sportId: dto.sportId,
        marketIds: dto.markets !== null ? new Set(dto.markets) : new Set(),
    };
}
